import React from "react";
import { Box, Radio, FormControlLabel, Typography } from "@mui/material";

/**
 * Componente individual para cada opção de recorrência
 */
const RecurrenceOption = React.memo(
  ({ value, label, isSelected, onChange }) => {
    return (
      <Box
        sx={{
          border: "1px solid #dddbdb",
          borderRadius: "4px",
          width: { xs: "96%", sm: "48%" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          cursor: "pointer",
          fontWeight: 500,
        }}
        onClick={onChange}
      >
        <FormControlLabel
          value={value}
          control={
            <Radio
              color="primary"
              checked={isSelected}
              onChange={onChange}
              slotProps={{
                input: {
                  'data-testid': `boostSubscription_recurrence${value}_input`,
                },
              }}
            />
          }
          label={label}
          sx={{
            "& .MuiFormControlLabel-label": {
              fontWeight: 600,
            },
          }}
        />
        {value === "Annual" && (
          <Typography
            sx={{
              position: "absolute",
              top: "50%",
              right: { xs: "30px", sm: "10px" },
              transform: "translateY(-50%)",
              color: "#008A00",
              fontSize: "14px",
              fontWeight: 600,
            }}
          >
            16% off
          </Typography>
        )}
      </Box>
    );
  }
);

/**
 * Componente que exibe as opções de recorrência (mensal/anual)
 *
 * @param {object} props - Propriedades do componente
 * @param {string} props.recurrence - Valor atual da recorrência
 * @param {function} props.setRecurrence - Função para alterar a recorrência
 * @param {function} props.t - Função de tradução
 */
const RecurrenceOptions = ({ recurrence, setRecurrence, t }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: { xs: "column", sm: "row" },
        gap: 2,
        width: "100%",
      }}
    >
      <RecurrenceOption
        value="Monthly"
        label={t("purchase.monthly")}
        isSelected={recurrence === "Monthly"}
        onChange={() => setRecurrence("Monthly")}
      />
      <RecurrenceOption
        value="Annual"
        label={t("purchase.annual")}
        isSelected={recurrence === "Annual"}
        onChange={() => setRecurrence("Annual")}
      />
    </Box>
  );
};

export default React.memo(RecurrenceOptions);
